import {
  SET_CARDS,
  LOAD_CARDS,
  LOAD_CARD_TEMPLATES,
  SET_CARD_TEMPLATES,
  ADD_NEW_CARD_TEMPLATE,
  REMOVE_CARD_TEMPLATE,
  UPDATE_CARD_TEMPLATE,
  RESET_CARD_TEMPLATES_STATE,
  TEMPLATE_PAGINATION,
  TEMPLATE_SAVING
} from '../mutationTypes'
import getCardTemplateStoreDefaultState from './cardTemplateDefaultState'

export default {
  [LOAD_CARDS](state, payload) {
    state.loadCards = payload
  },

  [TEMPLATE_SAVING](state, payload) {
    state.isTemplateSaving = payload
  },

  [LOAD_CARD_TEMPLATES](state, payload) {
    state.loadCardTemplates = payload
  },

  [SET_CARDS](state, payload) {
    state.cardList = payload
  },

  [SET_CARD_TEMPLATES](state, payload) {
    state.cardTemplatesList = payload
  },

  [ADD_NEW_CARD_TEMPLATE](state, payload) {
    state.cardTemplatesList = [...state.cardTemplatesList, payload]
  },
  [REMOVE_CARD_TEMPLATE](state, payload) {
    state.cardTemplatesList = state.cardTemplatesList.filter(
      template => template.id !== payload
    )
  },
  [UPDATE_CARD_TEMPLATE](state, payload) {
    let cardTemplatesList = state.cardTemplatesList
    let cardIndex = cardTemplatesList.findIndex(
      template => template.id === payload.id
    )
    cardTemplatesList[cardIndex].name = payload.name
    cardTemplatesList[cardIndex].message = payload.message

    state.cardTemplatesList = [...cardTemplatesList]
  },
  [RESET_CARD_TEMPLATES_STATE](state) {
    Object.assign(state, getCardTemplateStoreDefaultState())
  },
  [TEMPLATE_PAGINATION](state, payload) {
    state.totalRecords = payload
  }
}
